import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faPhone } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/logo.PNG"; // Your logo path
import "../styles/MainNavbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
  };

  return (
    <>
      {/* Top Navbar */}
      <div className="top-navbar">
        <div className="contact-info">
          <FontAwesomeIcon icon={faPhone} className="phone-icon" />
          <span>+91 9492446913 | Available: 24/7 HRS</span>
        </div>
        <div className="scrolling-text">
  <div className="scrolling-content" aria-label="Special offer announcement">
  Invite your friends & family to Mahindra Funeral Services and earn rewards!
  </div>
</div>
      </div>

      {/* Main Navigation Bar */}
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="Company Logo" className="logo-img" />
          </Link>

          {/* Mobile Menu Icon */}
          <div className="menu-icon" onClick={toggleMenu}>
            <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
          </div>

          {/* Navigation Links */}
          <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={toggleMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/services" className="nav-link" onClick={toggleMenu}>
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={toggleMenu}>
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/testimonials" className="nav-link" onClick={toggleMenu}>
                Testimonials
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link contact-btn" onClick={toggleMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
